<template>
    
    <div id="app" v-bind:class="{dpn:!pageInit}">


        <div
     
      class="payment"
    >
      <van-nav-bar title="重置密码" @click-left="goBack" left-arrow>
      </van-nav-bar>
    </div>

        <div>

            <div style="background-color: #1889F9;padding: .5rem .3rem 1.25rem .3em;text-align: left;position: relative;">
                <!-- <div class="fc-FFFFFF-fs-la-m">重置密码</div> -->


                <form style="position: absolute;top: 100%;left: .3rem;right: .3rem;border-radius: .075rem;background: #ffffff;transform: translateY(-30%)">
                    <div class="cus-row cus-row-v-m" style="border-bottom: 1px solid #E5E5E5">
                        <div class="cus-row-col-2 t-al-c"><img src="../assets/images/safety_certificate.png" style="width: 0.4rem"/></div>
                        <div class="cus-row-col-8"> <input placeholder="输入旧密码" class="fc-333333-fs-nor-r cus-input" style="border: none;" v-model="password" type="password"/></div>
                        <div class="cus-row-col-2"><span style="line-height: 1.2rem;">&nbsp;</span></div>
                    </div>

                    <div class="cus-row cus-row-v-m" style="border-bottom: 1px solid #E5E5E5">
                        <div class="cus-row-col-2 t-al-c"><img src="../assets/images/safety_certificate.png" style="width: 0.4rem"/></div>
                        <div class="cus-row-col-8"> <input placeholder="确认新密码" class="fc-333333-fs-nor-r cus-input" style="border: none;" v-model="new_password" type="password"/></div>
                        <div class="cus-row-col-2"><span style="line-height: 1.2rem;">&nbsp;</span></div>
                    </div>


                </form>

            </div>


            <div style="padding:.625rem .625rem 0 .625rem;margin-top: 2.11rem;" class="in-bl-line">
                <a class="bt" href="javascript:void(0);" v-on:click="nextStep">重置</a>
            </div>

        </div>

    </div>
</template>


<script>
    import common from '../assets/js/common'
import { resetPassword } from '../assets/js/api'

    export default {
        name: 'HelloWorld',
        props: {
            msg: String
        },
        components:
            {
            },
        data: function(){
            return {
                phone:'',
                second:'',
                smsText:'获取验证码',
                sms_code:'',
                pageInit:false,
                eduName:'教育分期',
                showProtocol:false,
                password:'',
                new_password:''
            }
        },
        methods:{
            goBack(){
                this.$router.go(-1);
            },
            back()
            {
                this.showProtocol = false;
            },
            protocol()
            {
                this.showProtocol = true;
            },
            nextStep(){


                // if( this.password.length < 6 )
                // {
                //     common.mAlert(this,'旧密码长度不能小于6位');
                //     return;
                // }

                if( this.new_password.length < 6 )
                {
                    common.mAlert(this,'新密码长度不能小于6位')
                    return;
                }



                resetPassword(this.password, this.new_password).then((res) => {
                    if (res.errcode === 0) {
                        if (res.access) {
                            common.setAuth(res.access)
                        }
                        common.mAlert(this, '重置成功')
                        this.$router.go(-1)
                    } else {
                        common.mAlert(this, res.errmsg)
                    }
                }).catch(() => {
                    common.mAlert(this, '服务异常')
                })
            }
        },
        created:function()
        {
            common.setTitle('修改密码');
            this.pageInit = 1;
        },
        mounted:function(){
            this.$store.commit('setTarbarIndex',3)
        }
    }
</script>


<style>
    html,body{background: #f8f8f8 !important;}
    html{min-height: 100%}

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }

    .disableText{color:#999999 !important;}

    .in-bl{display: inline-block;}

    p{font-size: 0.375rem;}
</style>